import {Route} from '@angular/router';
import {InitialDataResolver} from 'app/app.resolvers';
import {LayoutComponent} from './layout/layout.component';
import {MainGuard} from './core/guards/main.guard';

export const appRoutes: Route[] = [

    // Auth routes (guest)
    {
        path: 'auth',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {
                path: '',
                redirectTo: 'sign-in',
                pathMatch: 'full'
            },
            {
                data: {title: 'Email Verification'},
                path: 'verify/email/:hash',
                loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)
            },
            {
                data: {title: 'Password Recovery Step 1'},
                path: 'forgot-password',
                loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)
            },
            {
                data: {title: 'Password Recovery Step 2'},
                path: 'password/recovery/:hash',
                loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)
            },
            {
                path: 'sign-in',
                data: {title: 'Sign IN'},
                loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)
            },
            {
                path: 'sign-up',
                data: {title: 'Sign UP'},
                loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)
            }
        ]
    },


    // Admin routes
    {
        path: 'backend',
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        data: {
            layout: 'futuristic'
        },
        children: [
            {
                path: '',
                loadChildren: () => import('app/modules/backend/backend.module').then(m => m.BackendModule)
            }
        ]
    },

    {
        path: 'game',
        component: LayoutComponent,
        canActivate: [MainGuard],
        resolve: {
            initialData: InitialDataResolver,
        },
        data: {
            isGame: true,
            layout: 'centered'
        },
        children: [
            {
                path: ':id',
                loadChildren: () => import('app/modules/game/game.module').then(m => m.GameModule)
            }
        ]
    },

    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        data: {
            layout: 'centered'
        },
        children: [
            {
                path: '',
                loadChildren: () => import('app/modules/public/public.module').then(m => m.PublicModule)
            }
        ]
    },


    // 404 & Catch all
    {
        path: '404-not-found',
        pathMatch: 'full',
        data: {
            layout: 'empty'
        },
        loadChildren: () => import('app/modules/errors/errors.module').then(m => m.ErrorsModule)
    },
    {path: '**', redirectTo: '404-not-found'},
];
